var map = {
	"./ball-icon-1-active.png": 2112,
	"./ball-icon-1.png": 6142,
	"./ball-icon-2-active.png": 4364,
	"./ball-icon-2.png": 6419,
	"./ball-icon-3-active.png": 2562,
	"./ball-icon-3.png": 2679,
	"./ball-icon-4-active.png": 9042,
	"./ball-icon-4.png": 1122,
	"./ball-icon-5-active.png": 3927,
	"./ball-icon-5.png": 4024,
	"./ball-icon-6-active.png": 2570,
	"./ball-icon-6.png": 6774,
	"./bg.png": 1511,
	"./common-system-active.png": 9204,
	"./common-system.png": 6694,
	"./hazard-web-active.png": 8220,
	"./hazard-web.png": 6582,
	"./title-bg.png": 9804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5078;